import script from "./VendorDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorDialog.vue?vue&type=script&setup=true&lang=js"

import "./VendorDialog.vue?vue&type=style&index=0&id=5e094241&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e094241"]])

export default __exports__